export default __webpack_public_path__ + "static/media/project3-p2.a7ed78e1.png";